import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';
import { ProductsDTO } from '../models';

@Injectable({
  providedIn: 'root'
})
export class LogisticService extends __BaseService {

  static readonly logisticPath = '/Logistic';

  static productsPath(idEvent: number) {
    return LogisticService.logisticPath + '/' + idEvent;
  }
  static uploadPath(idEvent: number) {
    return LogisticService.logisticPath + '/' + idEvent + '/upload';
  }

  static exportPath(idEvent: number) {
    return LogisticService.logisticPath + '/export/' + idEvent;
  }

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * * GET LOGISTIC PRODUCTS
   * @param idEvent
   * @param params
   * @returns Get a list of products for manage logistic for event
   */
  getProductsResponse(idEvent: number, params: any): __Observable<__StrictHttpResponse<ProductsDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params) {
      if (params.Search) __params = __params.set('Search', params.Search.toString());
      if (params.SapCode) {
        params.SapCode.forEach((sapCode: string) => {
          __params = __params.append('SapCode', sapCode.toString());
        })
      }
      if (params.Statuses) {
        params.Statuses.forEach((status: string) => {
          __params = __params.append('Statuses', status.toString());
        })
      }
      if (params.AllocationStatus) {
        params.AllocationStatus.forEach((status: string) => {
          __params = __params.append('AllocationStatus', status.toString());
        })
      }
      if (params.OrderBy) __params = __params.set('OrderBy', params.OrderBy.toString());
      if (params.isDesc) __params = __params.set('isDesc', params.isDesc.toString());
      if (params.Skip) __params = __params.set('Skip', params.Skip.toString());
      if (params.Limit) __params = __params.set('Limit', params.Limit.toString());
    }

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + LogisticService.productsPath(idEvent),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<ProductsDTO>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ProductsDTO>;
      })
    );
  }
  getProducts(idEvent: number, params?: any): __Observable<any> {
    return this.getProductsResponse(idEvent, params).pipe(
      __map(_r => _r.body as ProductsDTO)
    );
  }

  updateProductResponse(requestBody?: any): __Observable<__StrictHttpResponse<any>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = requestBody;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + LogisticService.logisticPath,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<any>;
      })
    );
  }
  updateProduct(requestBody?: any): __Observable<any> {
    return this.updateProductResponse(requestBody).pipe(
      __map(_r => _r.body as any)
    );
  }

  /**
 * * UPLOAD
 * @param idEvent
 * @param file
 * @returns Import products for event
 */
  postUploadResponse(idEvent: number, file: File): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    const formData: FormData = new FormData();
    formData.append('file', file);
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + LogisticService.uploadPath(idEvent),
      formData,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<any>;
      })
    );
  }

  postUpload(idEvent: number, file: File): __Observable<Blob> {
    return this.postUploadResponse(idEvent, file).pipe(
      __map(_r => _r.body as any)
    );
  }

  /**
  * EXPORT PRODUCTS
  * @param idEvent
  * @returns blob file
  */
  getExportResponse(idEvent: number, params: any): __Observable<__StrictHttpResponse<any>> {
    let _params = this.getExportParams(params);
    if (params) {
      if (idEvent != null) _params = _params.set('idEvent', idEvent.toString());
    }
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + LogisticService.exportPath(idEvent),
      __body,
      {
        headers: __headers,
        params: _params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<any>;
      })
    );
  }
  getExport(idEvent: number, parameters: any): __Observable<any> {
    return this.getExportResponse(idEvent, parameters).pipe(
      __map(_r => _r.body as any)
    );
  }

  getExportParams(params: any) {
    let _params = this.newParams();
    if (params) {
      if (params.Search) _params = _params.set('Search', params.Search.toString());
      if (params.SapCode) {
        params.SapCode.forEach((sapCode: string) => {
          _params = _params.append('SapCode', sapCode.toString());
        })
      }
      if (params.Statuses) {
        params.Statuses.forEach((status: string) => {
          _params = _params.append('Statuses', status.toString());
        })
      }
      if (params.AllocationStatus) {
        params.AllocationStatus.forEach((status: string) => {
          _params = _params.append('AllocationStatus', status.toString());
        })
      }
      if (params.OrderBy) _params = _params.set('OrderBy', params.OrderBy.toString());
      if (params.isDesc) _params = _params.set('isDesc', params.isDesc.toString());
      if (params.Skip) _params = _params.set('Skip', params.Skip.toString());
      if (params.Limit) _params = _params.set('Limit', params.Limit.toString());
    }
    if (params.withImages) {
      _params = _params.set('exportWithImage', params.withImages);
    }
    return _params;

  }


}
